import { render, staticRenderFns } from "./ModalBody.vue?vue&type=template&id=404cbc78"
import script from "./ModalBody.vue?vue&type=script&lang=js"
export * from "./ModalBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports